import { DISTRICT_ZOOM } from '@/common/components/AMap/ts-config';
import { useSatellite } from '@/common/hook/Amap/useSatellite';
import useLatest from '@/common/hook/useLatest';
import { FC, useEffect } from 'react';
export const polygonZIndex = 50;

/**
 * @Description 围栏marker的样式、元素交互（hover、click）
 */
const BorderMarker:FC<{
  newPolygonData,
  mapIns,
  polygonListRef,
  setHoverPolygonId,
  polygonColor
}> = ({
  newPolygonData,
  mapIns,
  polygonListRef,
  setHoverPolygonId,
  polygonColor
}) => {
  const isSatellite = useSatellite();// 是否正在使用卫星地图
  const isSatelliteRef = useLatest(isSatellite);

  const mouseOver = (id) => {
    setHoverPolygonId(id);
  };
  const mouseOut = () => {
    setHoverPolygonId(0);
  };
  const drawCircle = (value) => {
    const circle = new window.AMap.Circle({
      center: [value?.lng, value?.lat],
      radius: value?.radius, // 半径（米）
      strokeColor: polygonColor(value),
      strokeWeight: 1.5,
      strokeOpacity: 1,
      fillOpacity: isSatelliteRef.current ? 0.4 : 0.2,
      strokeStyle: 'dashed',
      strokeDasharray: [10, 10],
      zooms: [DISTRICT_ZOOM, 20],
      fillColor: polygonColor(value),
      zIndex: polygonZIndex,
      bubble: true, // 为了支持在商圈围栏上测距
      extData: value
    });
    circle.on('mouseover', () => {
      mouseOver(value?.id);
    });
    circle.on('mouseout', () => {
      mouseOut();
    });
    polygonListRef.current.push(circle);
    mapIns.add(circle);
  };
  const drawPolygon = (value) => {
    const arr = value?.polygon?.map((item) => {
      return [+item?.lng, +item?.lat];
    });
    const polygon = new window.AMap.Polygon({
      path: arr,
      fillColor: polygonColor(value),
      strokeOpacity: 1,
      fillOpacity: isSatelliteRef.current ? 0.4 : 0.2,
      strokeColor: polygonColor(value),
      strokeWeight: 1.5,
      strokeStyle: 'dashed',
      zIndex: polygonZIndex,
      zooms: [DISTRICT_ZOOM, 20],
      anchor: 'bottom-center',
      bubble: true,
      extData: value
    });
    polygon.on('mouseover', () => {
      mouseOver(value?.id);
    });
    polygon.on('mouseout', () => {
      mouseOut();
    });
    polygonListRef.current.push(polygon);
    mapIns.add(polygon);
  };
  useEffect(() => {
    if (!mapIns) return;

    newPolygonData.map((item) => {
      if (item?.polygon) {
        drawPolygon(item);
        return;
      }
      if (item?.radius) {
        drawCircle(item);
        return;
      }
    });
  }, [mapIns, newPolygonData]);

  // 卫星模式下，围栏透明度加深
  // useEffect(() => {
  //   polygonListRef.current?.forEach((polygon) => {
  //     polygon.setOptions({
  //       fillOpacity: isSatellite ? 0.4 : 0.2,
  //     });
  //   });
  // }, [isSatellite]);
  return <></>;
};
export default BorderMarker;
